module.exports = __webpack_public_path__ + "img/tab_location-w.073db35d.svg";